"use client";

import dynamic from "next/dynamic";
import { MODAL_TYPES, useModalStore } from "~/stores/useModalStores";
const EditPersonalDataModal = dynamic(() => import("~/components/modals/EditPersonalDataModal"));
const EditShippingAddressModal = dynamic(() => import("~/components/modals/EditShippingAddressModal"));
const EditBillingAddressModal = dynamic(() => import("~/components/modals/EditBillingAddressModal"));
const UserIdVerificationModal = dynamic(() => import("~/components/modals/UserIdVerificationModal"));

const ModalRoot = () => {
    const { type, props } = useModalStore();

    if (!type) return null;

    switch (type) {
        case MODAL_TYPES.EDIT_PERSONAL_DATA:
            return <EditPersonalDataModal {...props} />;
        case MODAL_TYPES.EDIT_SHIPPING_ADDRESS:
            return <EditShippingAddressModal {...props} />;
        case MODAL_TYPES.EDIT_BILLING_ADDRESS:
            return <EditBillingAddressModal {...props} />;
        case MODAL_TYPES.USER_ID_VERIFICATION:
            return <UserIdVerificationModal {...props} />;
        default:
            return null;
    }
};

export default ModalRoot;
